import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useUser } from "../../../../../hook";
import { useMemo } from "react";
import { ITRepairInfoService } from "../../../../../services/it-repair/itRepairInfo.service";
import { approverType } from "../repairRequestType";

export const useDetailsRTR = () => {
  const { id } = useParams<{ id: string }>();
  const { checkCurrentUser } = useUser();

  const { data, isLoading } = useQuery({
    queryKey: ["repair-tools-requests", id],
    queryFn: () => ITRepairInfoService.getITRepairInfo(id),
    enabled: !!id,
  });

  const isPin = useMemo(() => {
    if (!data) return false;
    const pins: any[] = data.fields.ePins ? JSON.parse(data.fields.ePins) : [];
    return pins.findIndex((pin: string) => checkCurrentUser(pin)) >= 0;
  }, [checkCurrentUser, data]);

  const approvalType: number = useMemo(() => {
    if (!data) return 0;
    const { eApprovedBy, eApprovedByITHead, eAssignee, eApprovedStatus, eApprovedByITHeadStatus, eAssigneeStatus } =
      data?.fields;
    const approverEmail = eApprovedBy ? eApprovedBy.split("|")[0] : "";
    const approvedByITHeadEmail = eApprovedByITHead ? eApprovedByITHead.split("|")[0] : "";
    const assigneeEmail = eAssignee ? eAssignee.split("|")[0] : "";

    if (checkCurrentUser(approverEmail) && !eApprovedStatus) return approverType.approver;
    if (checkCurrentUser(approvedByITHeadEmail) && !eApprovedByITHeadStatus) return approverType.ithead;
    if (checkCurrentUser(assigneeEmail) && !eAssigneeStatus) return approverType.assignee;
    return 0;
  }, [data, checkCurrentUser]);

  const approvalStep: number = useMemo(() => {
    if (!data) return approverType.approver;
    const { eApprovedStatus, eApprovedByITHeadStatus, eAssigneeStatus } = data?.fields;
    if (!eApprovedStatus) return approverType.approver;
    if (!eApprovedByITHeadStatus) return approverType.ithead;
    if (!eAssigneeStatus) return approverType.assignee;
    return approverType.approver;
  }, [data]);

  return { data, isLoading, isPin, approvalStep, approvalType };
};
